export default "__VITE_ASSET__dAPe5ZtP__"